


































































































































import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import mdui from "mdui";

@Component
export default class login extends Vue {
  private butValue: string = "注册/找回";
  private userName: string = "";
  private email: string = "";
  private verifyCode: string = "";
  private passWord: string = "";
  private tooPassWord: string = "";
  private loginDialog: any = null;
  private tpflag: boolean = false;

  constructor() {
    super();
    this.updateToken();
  }

  get flag(): number {
    return this.$store.state.loginFlag;
  }

  set flag(flag: number) {
    // @ts-ignore
    this.$store.commit("openLogin", flag);
  }

  @Watch("flag")
  public update() {
    if (this.flag == 9) return; // 约定刷新的数字，用来保证每次调用都watch住
    if (this.loginDialog == null) {
      this.loginDialog = new mdui.Dialog("#login"); //登录弹出框对象
    }

    this.loginDialog.open();
    setTimeout(() => {
      // 刷新dialog
      this.loginDialog.handleUpdate();
    }, 10);

    // 更新左侧按钮
    if (this.flag == 0) {
      this.butValue = "登录/找回密码";
    } else if (this.flag == 1) {
      this.butValue = "注册/找回密码";
    } else if (this.flag == 2) {
      this.butValue = "登录/注册";
    }
  }

  public login() {
    const data = JSON.stringify({
      userName: this.userName,
      passWord: this.passWord,
    });
    // @ts-ignore
    this.$httpService.postData(data, false, "login").then(
      (result: any) => {
        this.$store.commit("setToken", result.result);
        //保存用户名
        this.$store.commit("setUserName", this.userName);
        // @ts-ignore 调用获取list
        this.$store.commit("getMarkList");
        // 关闭对话框
        this.loginDialog.close();
      },
      (error: any) => {
        console.log(error);
      }
    );
  }

  public signUp() {
    var isError = document.querySelector(".mdui-textfield-invalid-html5"); //TODO 不一样和文档
    //判断是否都有值
    var s =
      this.userName.length *
      this.passWord.length *
      this.email.length *
      this.tooPassWord.length;
    //TODO  如果有没输入的值可能不报错
    if (isError != null || s == 0) {
      mdui.snackbar({
        message: "请检查输入",
        position: "top",
      });

      return;
    }
    const data = JSON.stringify({
      userName: this.userName,
      passWord: this.passWord,
      code: this.verifyCode,
      email: this.email,
    });

    // @ts-ignore
    this.$httpService.postData(data, true, "signUp", "application/json").then(
      (result: any) => {
        // 关闭对话框
        this.loginDialog.close();
        this.login();
      },
      (error: any) => {}
    );
  }

  public updateToken() {
    if (this.$store.state.token) {
      // @ts-ignore
      this.$httpService
        .postData(null, true, "updateToken", "application/json")
        .then(
          (result: any) => {
            console;
            this.$store.commit("setToken", result.result);
          },
          (error: any) => {
            setTimeout(() => {
              localStorage.clear(); //清除缓存
              window.location.reload(); //刷新页面
            }, 100); //调用自动注销
          }
        );
    }
  }

  public checkPassWord() {
    if (this.passWord == this.tooPassWord) {
      this.tpflag = false;
      mdui.$("#tooPassWord").removeClass("mdui-textfield-invalid");

      return true;
    } else {
      this.tpflag = true;
      mdui.$("#tooPassWord").addClass("mdui-textfield-invalid");
      return false;
    }
  }

  // 显示验证码
  public Captchashow() {
    var nc_token = [
      "FFFF0N0N000000008342",
      new Date().getTime(),
      Math.random(),
    ].join(":");
    // @ts-ignore
    var vwidth = document.getElementById("emailInput").offsetWidth;
    var sendEmailCode = this.sendEmailCode;
    var NC_Opt = {
      renderTo: "#your-dom-id",
      appkey: "FFFF0N0N000000008342",
      scene: "nc_register",
      token: nc_token,
      customWidth: vwidth,
      trans: { key1: "code0" },
      elementID: ["usernameID"],
      is_Opt: 0,
      language: "cn",
      isEnabled: true,
      timeout: 3000,
      times: 5,
      apimap: {
        // 'analyze': '//a.com/nocaptcha/analyze.jsonp',
        // 'get_captcha': '//b.com/get_captcha/ver3',
        // 'get_captcha': '//pin3.aliyun.com/get_captcha/ver3'
        // 'get_img': '//c.com/get_img',
        // 'checkcode': '//d.com/captcha/checkcode.jsonp',
        // 'umid_Url': '//e.com/security/umscript/3.2.1/um.js',
        // 'uab_Url': '//aeu.alicdn.com/js/uac/909.js',
        // 'umid_serUrl': 'https://g.com/service/um.json'
      },
      callback: function (data: any) {
        // @ts-ignore
        sendEmailCode(data);
      },
    };
    // // @ts-ignore
    // /* eslint-disable */
    var nc = new (window as any).getnoCaptcha(NC_Opt);
    /* eslint-disable */
    nc.upLang("cn", {
      _startTEXT: "拖动滑块，发送验证码",
      _yesTEXT: "正在验证邮箱",
      _error300:
        '哎呀，出错了，点击<a href="javascript:__nc.reset()">刷新</a>再来一次',
      _errorNetwork:
        '网络不给力，请<a href="javascript:__nc.reset()">点击刷新</a>',
    });

    setTimeout(() => {
      // 刷新dialog
      this.loginDialog.handleUpdate();
    }, 200);
  }

  public sendEmailCode(indata: any) {
    const data = JSON.stringify({
      email: this.email,
      noCaptcha: indata,
    });
    // @ts-ignore
    this.$httpService
      .postData(data, false, "signUp/sendEmailCode", "application/json")
      .then(
        (result: any) => {
          //提示用户检查垃圾邮箱
          mdui.$("#emailCode").addClass("mdui-textfield-invalid");
        },
        (error: any) => {
          this.Captchashow();
        }
      );
  }
}
